import { LoginPage } from '@features/onboarding/components/login/LoginPage';
import { InvitationSearchSchema } from '@routes/searchSchemas';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/login')({ validateSearch: InvitationSearchSchema, component: LoginPage });
